<script>
    import { scrolledDown } from '../stores'

    let scrolled = false;

    scrolledDown.subscribe(value => {
        scrolled = value;
    });

</script>

<footer id="site-footer" class="site-footer { scrolled ? 'scrolled' : '' }">
    <div class="note">
        <a class="funding-link" href="https://sei.org" target="_blank">
            <img src='../img/logo_sei.png' alt="Stockholm Environment Institute">
        </a>
        <a class="funding-link text" href="https://trafikverket.se" target="_blank">
            <img src="../img/logo_trafikverket.png" alt="Trafikverket">
            Funded by Trafikverket
        </a>
    </div>

</footer>